/* istanbul ignore file */
import { IPRangeMixin } from './IPRangeMixin';
const IPRangeParser = /* #__PURE__ */ IPRangeMixin;
export class IPRange extends IPRangeMixin {
    static decode(input) {
        return IPRangeParser.decode(input).map(res => new IPRange(res));
    }
    static unsafeDecode(input) {
        return IPRange.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IPRangeParser.encode(data);
    }
    static schema() {
        return IPRangeParser.schema();
    }
}
